import { FC, useEffect, useMemo, useState } from 'react';
import { Input, Form, Modal, Button } from '@maxtropy/components';
import { Space } from 'antd';
import {
  apiV2EnergyAnalysisSetDifferenceDescPost,
  apiV2EnergyAnalysisGetDifferenceDescPost,
} from '@maxtropy/device-customer-apis-v2';

interface DescribeSetProps {
  fontModalOpen: boolean;
  setFontModalOpen: (v: boolean) => void;
}

const DescribeSetModal: FC<DescribeSetProps> = ({ fontModalOpen, setFontModalOpen }) => {
  const [form] = Form.useForm();
  const [dates, setDates] = useState();
  const [isEdit, setIsEdit] = useState<boolean>(true);

  useEffect(() => {
    apiV2EnergyAnalysisGetDifferenceDescPost({}).then(res => {
      form.setFieldsValue({
        upstreamGreaterThanDownstream: res?.upstreamGreaterThanDownstream,
        downstreamGreaterThanUpstream: res?.downstreamGreaterThanUpstream,
      });
    });
  }, []);

  const onCancel = () => {
    setIsEdit(true);
    setFontModalOpen(false);
  };
  // 弹框确认
  const onOk = () => {
    form.validateFields().then(values => {
      apiV2EnergyAnalysisSetDifferenceDescPost({ ...values }).then(res => {
        onCancel();
      });
    });
  };

  return (
    <Modal
      title="上下级用能差异文描设置"
      open={fontModalOpen}
      contentClassName="modal-form-content"
      onCancel={onCancel}
      footer={
        <Space size={8}>
          {isEdit ? (
            <Button type="primary" onClick={() => setIsEdit(false)}>
              编辑
            </Button>
          ) : (
            <>
              <Button onClick={onCancel}>取消</Button>
              <Button type="primary" onClick={onOk}>
                保存
              </Button>
            </>
          )}
        </Space>
      }
    >
      <Form form={form} isOrigin={true}>
        <Form.Item
          label="上级用能大于下级用能"
          name="upstreamGreaterThanDownstream"
          rules={[{ required: true }]}
          style={{ marginTop: 20 }}
        >
          <Input placeholder="请输入" disabled={isEdit} />
        </Form.Item>

        <Form.Item label="下级用能大于上级用能" name="downstreamGreaterThanUpstream" rules={[{ required: true }]}>
          <Input placeholder="请输入" disabled={isEdit} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DescribeSetModal;
